import { render, staticRenderFns } from "./VirtualAutocomplete.vue?vue&type=template&id=0acff512&scoped=true"
import script from "./VirtualAutocomplete.vue?vue&type=script&lang=js"
export * from "./VirtualAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acff512",
  null
  
)

export default component.exports